/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Interact_MixInputs */

const en_onboarding_interact_mix = /** @type {(inputs: Onboarding_Interact_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mix of the above`)
};

const es_onboarding_interact_mix = /** @type {(inputs: Onboarding_Interact_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mezcla de todo lo anterior`)
};

/**
* | output |
* | --- |
* | "Mix of the above" |
*
* @param {Onboarding_Interact_MixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_interact_mix = /** @type {((inputs?: Onboarding_Interact_MixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Interact_MixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_interact_mix(inputs)
	return en_onboarding_interact_mix(inputs)
});